<template>
  <div id="app">
    <router-view :key="$router.fullPath" />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    window.addEventListener("copy", function (e) {
      return false;
    });
  },
};
</script>
<style lang="less" >
#app {
  width: 100%;
  height: 100%;
}
</style>




// WEBPACK FOOTER //
// src/App.vue